export default "__VITE_ASSET__OzPPMWVC__"